import UserName from "./UserName";
import UserLink from "./UserLink";

import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="User-detail-title"
                    >
                        { label || t`User` }: <UserName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="User-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="User-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="email-label" sx={{ textAlign: "left" }}><Trans>Email</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="email-value" sx={{ textAlign: "left" }}>{ data.email || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="activated-label" sx={{ textAlign: "left" }}><Trans>Activated</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="activated-value" sx={{ textAlign: "left" }}>{ data.activated ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="banned-label" sx={{ textAlign: "left" }}><Trans>Banned</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="banned-value" sx={{ textAlign: "left" }}>{ data.banned ? (<CheckBoxOutlinedIcon/>) : (<CheckBoxOutlineBlankOutlinedIcon/>) }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="createdAt-label" sx={{ textAlign: "left" }}><Trans>Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="createdAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.createdAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="updatedAt-label" sx={{ textAlign: "left" }}><Trans>Updated At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="updatedAt-value" sx={{ textAlign: "left" }}>{displayDateTime(data.updatedAt) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="userGroupId-label" sx={{ textAlign: "left" }}><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="userGroupId-value" sx={{ textAlign: "left" }}>{ data.userGroupId ? (<MembersGroupLink id={ data.userGroupId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default UserDetail;
